import { useExperimentVariables } from '@mc/experiments-react'
import { BOGO_OFFER_VARIABLES_FLAG_NAME } from '../constants'

export interface HeroImage {
  firstColumn: string
  secondColumn: string
}

export const useHomePageBogoHeroImages = (
  defaultImages: HeroImage[],
): HeroImage[] => {
  const variables = useExperimentVariables(BOGO_OFFER_VARIABLES_FLAG_NAME)
  const promoImages = variables?.home_page_hero_images as HeroImage[]

  if (Array.isArray(promoImages) && promoImages.length > 0) {
    return promoImages
  }

  return defaultImages
}
